import { lazyLoad } from 'utils/loadable';

export const PublicAssetsPage = lazyLoad(
  () => import('./index'),
  module => module.PublicAssetsPage,
);
